import React, {useEffect, useRef, useState} from 'react';
import './ImportDocumentIssuance.scss';
import DynaDatePicker from "../../DynaView/DynaDatePicker";
import DynaTimePicker from "../../DynaView/DynaTimePicker";
import DynaInput from "../../DynaView/DynaInput";
import NumericFunction from "../../../../utils/NumericFunction";
import DynaButton from "../../DynaView/DynaButton";
import {useNavigate} from "react-router-dom";
import utilsFunction from "../../../../utils/utilsFunction";
import {exportXLSXFile} from "../../../../utils/exportCSVFile";
import {toast} from "react-toastify";
import _axios from "../../../../httpService";
import {prefixUrl} from "../../../../utils/utilsData";
import Loader from "../../../Loader";

const ImportDocumentIssuance = () => {

  const navigateTo = useNavigate();
  const fileInputRef = useRef(null);
  const options = {year: 'numeric', month: '2-digit', day: '2-digit', calendar: 'persian'};
  const todayDate = new Date().toLocaleDateString('fa-IR', options);

  const now = new Date();
  const hours = now.getHours().toString().padStart(2, '0');
  const minutes = now.getMinutes().toString().padStart(2, '0');
  const seconds = now.getSeconds().toString().padStart(2, '0');

  const [sendData, setSendData] = useState({
    request: "excelConfirm",
    documentDescription: "",
    documentDate: "",
    documentTime: "",
  });
  const [file, setFile] = useState(null);
  const [isLoad, setIsLoad] = useState(true)

  useEffect(() => {
    setSendData({
      ...sendData,
      documentDate: NumericFunction.p2e(todayDate),
      documentTime: `${hours}:${minutes}:${seconds}`,
    })
  }, []);

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const downloadSampleFile = () => {
    const column = [
      {field: "c1", title: "ردیف"},
      {field: "c2", title: "کد معین"},
      {field: "c3", title: "کد تفضیل"},
      {field: "c4", title: "شرح"},
      {field: "c5", title: "بدهکار"},
      {field: "c6", title: "بستانکار"},
    ]
    const data = [
      {c1: "1", c2: "50020002", c3: "", c4: "حساب معین مستقیم", c5: "4000", c6: ""},
      {c1: "2", c2: "10020002", c3: "10100", c4: "حساب معین همراه با تفصیلی", c5: "", c6: "4000"},
    ]
    const fileName = "اکسل نمونه";
    const normalizeData = utilsFunction.convertTabulatorDataToJson(column, data)
    exportXLSXFile(normalizeData, fileName, "")
  }

  const submitDataHandler = async () => {
    if (sendData?.documentDate === "") {
      return toast.error("تاریخ را وارد کنید")
    }
    if (sendData?.documentTime === "") {
      return toast.error("زمان را وارد کنید")
    }
    if (sendData?.documentDescription === "") {
      return toast.error("توضیحات را وارد کنید")
    }
    if (file === null) {
      return toast.error("فایل اکسل را وارد کنید")
    }

    let formData = new FormData();
    formData.append('request', sendData?.request);
    formData.append('documentDate', sendData?.documentDate);
    formData.append('documentTime', sendData?.documentTime);
    formData.append('documentDescription', sendData?.documentDescription);
    formData.append('import_file', file);

    setIsLoad(false)

    const response = await _axios.post(prefixUrl() + "/accountingDocument/", formData)
    if (response?.data.status) {
      toast.success(response?.data?.message)
      navigateTo("/coding/DocumentIssuance", {
        state: {
          id: response?.data?.documentCode,
          manualDocumentId: response?.data?.documentCode,
          mode: "edit",
          title: "ویرایش سند"
        }
      })
    } else {
      toast.error(response?.data?.message)
      setIsLoad(true)
    }
  }

  return (
    <section className={"ImportDocumentIssuance"}>
      {isLoad ?
        <div className={"form-import-document"}>
          <DynaDatePicker label={"تاریخ"}
                          name={"documentDate"}
                          className={"solid-dyna-input"}
                          value={sendData?.documentDate}
                          setDataFromComponent={(data) => {
                            setSendData({...sendData, ...data})
                          }}
          />


          <DynaTimePicker
            name={"documentTime"}
            label="زمان"
            className={"solid-dyna-input"}
            value={sendData?.documentTime}
            setDataFromComponent={(data) => {
              setSendData({...sendData, ...data})
            }}
          />

          <div style={{gridColumn: "1/-1"}}>
            <DynaInput label={"توضیحات"}
                       name={"documentDescription"}
                       className={"solid-dyna-input"}
                       placeholder={"توضیحات را وارد کنید"}
                       value={sendData?.documentDescription}
                       type={"text"}
                       setDataFromComponent={(data) => {
                         setSendData({...sendData, ...data})
                       }}
            />
          </div>

          <input
            style={{display: 'none'}}
            type="file"
            accept=".xlsx, .xls"
            onChange={handleFileChange}
            ref={fileInputRef}
          />
          <button type="button" onClick={() => fileInputRef.current.click()} className={"upload-file-but"}>
            {file ? file?.name : "بارگذاری فایل اکسل"}
          </button>

          <button className={"download-file-but"} onClick={downloadSampleFile}>
            دانلود نمونه اکسل
          </button>

          <div className={"button-side"}>
            <DynaButton className={"simple-but"}
                        type={"button"}
                        onClick={submitDataHandler}>ثبت</DynaButton>
            <DynaButton className={"simple-but-no-bac"}
                        type={"button"}
                        onClick={() => navigateTo(-1)}>انصراف</DynaButton>
          </div>
        </div> : <Loader/>}
    </section>
  );
};

export default ImportDocumentIssuance;